const setDisplayName = displayName => Component => {
  Component.displayName = displayName
  return Component
}
export default setDisplayName
